import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { Circles } from '../../common/loadingComponent';
import { reportActions } from '../../../store/reportStore';
import { monitoraActions } from '../../../store/monitoraStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Message from '../../common/message';
import BbPopover from '../../common/popover';
import MonitoraAnnotationRow from './monitoraAnnotationRow';

class MonitoraAnnotations extends React.Component {
    mounted = false;

    render() {
        const { data } = this.props.sections.find(o => o.id === this.props.sectionId);
        if (data === false)
            return <div><Message type="error" message={this.props.translate("Report.Monitora.UserNotConfiguredCorrectly")} shadowed /></div>

        const annotationsData = this.props.monitora.annotations;
        if (annotationsData.isLoading)
            return <Circles />

        if (annotationsData.error)
            return <div><Message type="error" message={this.props.translate(annotationsData.error)} shadowed /></div>

        if (isNullOrUndefined(annotationsData.annotations) || annotationsData.annotations.length === 0)
            return (
                <div className="no-data" style={this.props.style}>
                    <Translate id="Search.NoAnnotation" />
                </div>
            )

        return (
            <div className="columns">
                <div className="column is-12-desktop">
                    <table className="table table-report-section table-monitora-annotations without-hover fixed">
                        <thead>
                            <tr>
                                <th style={{ width: "12%" }}><Translate id="Report.Monitora.Published" /></th>
                                <th style={{ width: "55%" }}><Translate id="Report.Monitora.Headline" /></th>
                                <th style={{ width: "8%" }}><Translate id="Report.Monitora.MediaType" /></th>
                                <th style={{ width: "17%" }}><Translate id="Report.Monitora.Source" /></th>
                                <th style={{ width: "8%" }}>
                                    <Translate id="Report.Monitora.Sentiment" />
                                    <BbPopover title={this.props.translate("Report.Monitora.Sentiment")} content={this.props.translate("Report.Monitora.Sentiment.Help")} placement="left" targetId="monitora-annotation-sentiment-popover">
                                        <span href="#" className="icon-gray print-hidden" id="monitora-annotation-sentiment-popover" style={{ cursor: "pointer", marginLeft: "0.5em" }}>
                                            <FontAwesomeIcon icon="question-circle" />
                                        </span>
                                    </BbPopover>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {annotationsData.annotations.map(a => <MonitoraAnnotationRow key={a.article_id} article={a} entityId={this.props.id} />)}
                        </tbody>
                    </table>
                    {annotationsData.isLoadingMore && <div style={{ display: "flex", justifyContent: "center" }}>
                        <Circles />
                    </div>}
                    {!isNullOrUndefined(annotationsData.nextPageToken) && <div style={{ display: "flex", justifyContent: "center" }}>
                        <button className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                            onClick={() => this.props.getAnnotationsNextPage(annotationsData.nextPageToken)}
                        >
                            <Translate id="Report.Monitora.LoadMore" />
                        </button>
                    </div>}
                </div>
            </div>
        )
    }

    componentDidMount() {
        const { data } = this.props.sections.find(o => o.id === this.props.sectionId);
        if (data === true)
            this.props.getAnnotations(this.props.id, null, null);
        this.mounted = true;
    }
}

export default withLocalize(withRouter(connect(
    state => ({ ...state.report, monitora: state.monitora }),
    dispatch => bindActionCreators({ ...reportActions, ...monitoraActions }, dispatch)
)(MonitoraAnnotations)));